export default {
  "betActivity.thead.index": "#NO",
  "betActivity.thead.loopMethod": "LoopMethod",
  "betActivity.thead.isTimeLimit": "IsTimeLimit",
  "betActivity.thead.specifiedTime": "SpecifiedTime",
  "betActivity.thead.selectDayOfWeek": "SelectDayOfWeek",
  "betActivity.thead.selectDay": "SelectDay",
  "betActivity.thead.betProviderType": "BetProviderType",
  "betActivity.thead.betProviderValues": "BetProviderSelect",
  "betActivity.thead.betGameTypeValues": "BetGameTypesSelect",
  "betActivity.thead.getBonusType": "GetBonusType",
  "betActivity.thead.betAmount": "BetAmount",
  "betActivity.thead.bonusAmount": "BonusAmount",
  "betActivity.thead.rollover": "Rollover",

  "betActivity.thead.action": "Action",
  "betActivity.add": "Add",
  "betActivity.delete": "Delete",
};
